<button class="dcl-link button" [ngClass]="config.dclLinkClass" (click)="openModal()">
    <ng-content></ng-content>
</button>
